export { ProductService } from './service-setup/ProductService';

export { IProductSkuMap } from './internal/domain/entities/ProductSku';

import { diContainer, serviceNames } from './service-setup/diContainer';

diContainer.get(serviceNames.productService).register();
